import { Injectable, EventEmitter } from '@angular/core';
import { CartoService } from './carto.service';
import { environment } from '../../environments/environment.barcelona';

// TODO: Interfaces, Enum, etc

@Injectable()
export class AMBService extends CartoService {

  getTraffic(): any {
    return this.queryData(`
    SELECT
  s.cartodb_id,
  ST_PointOnSurface(s.the_geom_webmercator) AS the_geom_webmercator,
  round(avg(j.level)) AS level
FROM
  amb_streets s
  JOIN amb_waze_data_jams_agg_hour j ON
    ST_INTERSECTS(
      s.the_geom,
      ST_MakeEnvelope(
        2.1193313598632812,
        41.384021583849886,
        2.1478271484375,
        41.40359574314669,
        4326
      )
    )
    AND date(j.georss_date) = '2021-03-20'
    AND s.ntram = ANY (j.ntram_arr)
GROUP BY
  s.cartodb_id,
  s.the_geom_webmercator;
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/amb.service.ts